





































































import BaseComponent from '@/components/base-component.vue';
import DoctorForm from '@/components/doctors/doctor-form.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ArrayUtils from '@/helpers/arrayUtils';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import IDoctor from '@/interfaces/doctor';
import { checkUserPermissions } from '@/services/auth';
import * as service from '@/services/doctors';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { isArray } from 'lodash';
import { Observable } from 'rxjs';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import DoctorModel from '../../models/doctor-model';

@Component({
  components: { PermissionAuth, DoctorForm },
})
export default class UiSelectDoctor extends BaseComponent {
  @Prop({
    default: 'Médico',
  })
  public label!: string;
  @Prop({
    default: null,
  })
  public items: IDoctor[];
  @Prop()
  public value!: IDoctor | IDoctor[];
  @Prop({
    default: '',
  })
  public suffix?: string;
  @Prop({
    default: 'Digite o nome ou CRM do médico',
  })
  public placeholder?: string;
  @Prop({
    default: null,
  })
  public unitId?: number;
  @Prop({
    default: '',
  })
  public height?: string;
  @Prop({
    default: false,
  })
  public loading?: boolean;
  @Prop({
    default: true,
  })
  public returnObject?: boolean;
  @Prop({
    default: false,
  })
  public singleLine?: boolean;
  @Prop({
    default: false,
  })
  public outline?: boolean;
  @Prop({
    default: false,
  })
  public required?: boolean;
  @Prop({
    default: false,
  })
  public hideDetails?: boolean;
  @Prop({
    default: false,
  })
  public disabled?: boolean;
  @Prop({
    default: () => [],
  })
  public rules?: any[];
  @Prop({
    default: false,
  })
  public multiple?: boolean;
  @Prop({
    default: false,
  })
  public chips?: boolean;
  @Prop({
    default: false,
  })
  public clearable?: boolean;
  @Prop({
    default: false,
  })
  public deletableChips?: boolean;
  @Prop({
    default: false,
  })
  public showInactives?: boolean;

  @Prop({
    default: false,
  })
  public loadClientUnits?: boolean;

  @Prop({
    default: null,
  })
  public clientUnitsIds?: number[];

  @Prop({
    default: null,
  })
  public clientsIds?: number[];  

  @Prop({
    default: () => {
      return null;
    },
  })
  public newDoctorAction?: () => void;

  @Prop({ default: false })
  public showNewDoctorButton?: false;

  @Prop({default: false})
  public showIcon?: boolean;

  @Prop()
  public hint?: string;

  @Prop({default: false})
  public persistentHint?: boolean;

  isShowNewDoctorButtonInterno(): boolean {
    return (
      this.showNewDoctorButton &&
      checkUserPermissions([PERMISSIONS_KEYS.DOCTOR_INSERT]) &&
      !this.disabled
    );
  }

  public item: any = null;
  public doctorsLoading: boolean = false;

  private doctorsList: IDoctor[] = [];

  public itemDoctor: DoctorModel = null;
  public formDoctorOpen = false;
  public formDoctorIsEdit = false;
  public formDoctorIsView = false;

  @Watch('value')
  public onValChanged(val: IDoctor | IDoctor[]): void {
    this.item = val;
    this.setCurrentItem(val);
  }

  @Watch('items')
  public onItemsChanged(items: IDoctor[]): void {
    if (!!items) {
      this.doctorsList = items;
    }
  }

  @Watch('loading')
  public onLoadingChanged(loading: boolean): void {
    this.doctorsLoading = loading;
  }

  @Watch('unitId')
  public onUnitIdChanged(): void {
    this.getDoctors();
  }

  @Watch('clientUnitsIds')
  public onClientUnitsIdsChanged(n, o): void {
    if (ArrayUtils.equalsIgnoreOrder(n, o)) {
      return;
    }
    this.getDoctorsDebounce();
  }

  @Watch('clientsIds')
  public onClientsIdsChanged(n, o): void {
    if (ArrayUtils.equalsIgnoreOrder(n, o)) {
      return;
    }
    this.getDoctorsDebounce();
  }

  public beforeMount(): void {
    if (!this.items) {
      this.getDoctors();
    }
    this.onValChanged(this.value);
  }

  public onChange(val): void {
    if (!val || !this.loadClientUnits) {
      this.$emit('input', this.item);
      this.$emit('change', val);
      return;
    }

    let idsMedicos = [-1];
    if (isArray(val)) {    
      idsMedicos = this.returnObject ? val.map(m => m.id) : val;    
    } else {
      idsMedicos = this.returnObject ? [val.id] : [val];  
    }
    this.doctorsLoading = true;
    service.getLeanDoctors(null, true, [], [], idsMedicos).subscribe(res=> {
      this.doctorsLoading = false;
      let selected = null;
      if (isArray(val)) {    
        selected = this.returnObject ? res : res.map(m=> m.id);    
      } else {
        selected = this.returnObject ? res[0] : res[0].id;  
      }
      this.$emit('input', selected);
      this.$emit('change', selected);
    });
  }

  public remove(item): void {
    const index = this.item.findIndex((el) => el.id === item.id);

    const NOT_FOUND = -1;
    if (index !== NOT_FOUND) {
      this.item.splice(index, 1);
    }
  }

  private setCurrentItem(currentItem: any): void {
    if (!isArray(currentItem)) {
      const itemExist = () =>
        this.doctorsList.some((item) => item.id === currentItem.id);

      if (!!currentItem && !itemExist() && this.returnObject) {
        this.doctorsList.push(currentItem);
      }
    } else {
      currentItem.map((item) => {
        this.setCurrentItem(item);
      });
    }
  }

  timeoutGetDoctors = null;
  private getDoctorsDebounce() {
    clearTimeout(this.timeoutGetDoctors);
    this.timeoutGetDoctors = setTimeout(() => {
      this.getDoctors();
    }, 300);
  }

  private getDoctors(): Observable<IDoctor[]> {
    this.doctorsList = [];
    let getDoctors;
    const status = !this.showInactives ? true : null;
    if (!!this.unitId) {
      getDoctors = service.getDoctorsCombo(status, [this.unitId], null);
    } else {
      getDoctors = service.getDoctorsCombo(status, this.clientUnitsIds, this.clientsIds);
    }

    if (!!getDoctors) {
      this.doctorsLoading = true;
      this.addSubsc(
        getDoctors.subscribe(
          (data) => {
            this.doctorsList = data;
            this.doctorsLoading = false;
            this.setCurrentItem(this.value);
          },
          () => {
            this.doctorsLoading = false;
            this.toast.show('Ocorreu um erro ao carregar os médicos', 'error');
          },
        ),
      );
    }
    return getDoctors;
  }

  public newDoctorActionInterno(): void {
    if (this.newDoctorAction) {
      this.newDoctorAction();
      return;
    }
    this.formDoctorOpen = true;
    this.formDoctorIsEdit = false;
    this.formDoctorIsView = false;
    this.itemDoctor = new DoctorModel();
  }

  saveDoctor(doctor: IDoctor): any {
    this.addSubsc(
      this.getDoctors().subscribe((doctors) => {
        setTimeout(() => {
          doctor = doctors.filter((f) => f.id === doctor.id)[0];
          this.item = doctor;
          this.onChange(doctor);
        }, 100);
      }),
    );
    this.closeDoctorForm();
  }

  closeDoctorForm(): any {
    this.itemDoctor = new DoctorModel();
    this.formDoctorOpen = false;
    resetModalScroll();
  }
}
